var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgErrortick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0437 69.4068C49.3727 69.1981 49.7316 69.0398 50.1048 68.9282C64.6205 64.5857 75.2003 51.1284 75.2003 35.2C75.2003 15.7596 59.4407 0 40.0003 0C20.5599 0 4.80029 15.7596 4.80029 35.2C4.80029 49.0489 12.798 61.0298 24.4266 66.7762C24.4398 66.7826 24.4344 66.8026 24.4198 66.8014V66.8014C24.4104 66.8007 24.4032 66.8097 24.4061 66.8187L27.6339 77.0402C28.4249 79.5448 31.374 80.6203 33.5916 79.213L49.0437 69.4068Z",
    fill: "#FD504F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8134 28.6379C50.6418 27.8095 50.6418 26.4664 49.8134 25.638L49.362 25.1865C48.5336 24.3581 47.1904 24.3581 46.362 25.1865L40 31.5486L33.6379 25.1865C32.8095 24.3581 31.4664 24.3581 30.638 25.1865L30.1865 25.638C29.3581 26.4664 29.3581 27.8095 30.1865 28.6379L36.5486 35L30.1865 41.362C29.3581 42.1904 29.3581 43.5336 30.1865 44.362L30.638 44.8134C31.4664 45.6419 32.8095 45.6419 33.6379 44.8134L40 38.4514L46.362 44.8134C47.1904 45.6418 48.5336 45.6419 49.362 44.8134L49.8134 44.362C50.6419 43.5336 50.6418 42.1904 49.8134 41.362L43.4514 35L49.8134 28.6379Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrortick);
export default __webpack_public_path__ + "static/media/errortick.f9d79b2b86c08920618b68e9fa96a6bc.svg";
export { ForwardRef as ReactComponent };